import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie'

/**
 * DEV ONLY: Quick login page for local development
 * Access: /dev-login
 * 
 * This allows testing without running adnexio-next
 * Add your access token and it will set cookies automatically
 */
export default function DevLogin() {
    const navigate = useNavigate()
    const [token, setToken] = useState('')
    const [message, setMessage] = useState('')

    const handleQuickLogin = () => {
        if (!token) {
            setMessage('Please enter a token')
            return
        }

        const cookies = new Cookies()
        const expires = new Date()
        expires.setDate(expires.getDate() + 30) // 30 days from now

        // Set cookies using env domain
        const domain = process.env.REACT_APP_DOMAIN
        cookies.set('access_token', token, {
            path: '/',
            expires,
            domain,
        })
        cookies.set('token_expired', Math.floor(Date.now() / 1000) + (30 * 24 * 60 * 60), {
            path: '/',
            expires,
            domain,
        })

        setMessage('✅ Cookies set! Redirecting...')
        setTimeout(() => {
            window.location.href = '/'
        }, 1000)
    }

    // Only allow in local development to ensure staging mirrors production
    const isAllowed = process.env.REACT_APP_ENV === 'local'

    useEffect(() => {
        if (!isAllowed) {
            navigate('/')
        }
    }, [navigate, isAllowed])

    if (!isAllowed) {
        return null
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
            <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
                <h1 className="mb-4 text-2xl font-bold text-gray-800">🛠️ Dev Login</h1>
                <p className="mb-6 text-sm text-gray-600">
                    This page is only available in local development. Paste your access token to set cookies and login automatically.
                </p>

                <div className="mb-4">
                    <label className="mb-2 block text-sm font-medium text-gray-700">
                        Access Token
                    </label>
                    <textarea
                        className="w-full rounded border border-gray-300 p-2 text-sm"
                        rows={4}
                        placeholder="Paste your access_token here..."
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                    />
                </div>

                <button
                    onClick={handleQuickLogin}
                    className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                >
                    Set Cookies & Login
                </button>

                {message && (
                    <div className={`mt-4 rounded p-3 text-sm ${message.includes('✅') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                        {message}
                    </div>
                )}

                <div className="mt-6 rounded bg-gray-50 p-4">
                    <p className="mb-2 text-xs font-semibold text-gray-700">How to get a token:</p>
                    <ol className="list-inside list-decimal space-y-1 text-xs text-gray-600">
                        <li>Login to staging or local adnexio-next</li>
                        <li>Open DevTools → Application → Cookies</li>
                        <li>Copy the <code className="rounded bg-gray-200 px-1">access_token</code> value</li>
                        <li>Paste it above and click the button</li>
                    </ol>
                </div>
            </div>
        </div>
    )
}
